import { FC } from 'react';
import clsx from 'clsx';
import { StyledCompareCard } from './CompareCard.styles';
import { MButton, MButtonType } from '@marriott/mi-web-ui-kit';
import { Text, tags, size } from '@marriott/mi-ui-library';
import { CobrandImage } from '../../../molecules/CobrandImage/CobrandImage';
import { useStore } from '../../../modules/store/cobrandStore';
import { CompareCardProps } from './CompareCard.types';
import { useLandscapeOrientation } from '../../../modules/utils';
import { CardType } from '../../../modules/constants';

const applyTagStyles = (cardtype: CardType) => (cardtype === 'business' ? 'business-badge' : '');

export const CompareCard: FC<CompareCardProps> = ({ index, item, defaultContent, styleClass, hideShellSubtitle }) => {
  const { cobrandData, setCobrandData } = useStore(store => store);
  const isLandscape = useLandscapeOrientation();

  const handleRemove = (id: string) => {
    setCobrandData({
      ...cobrandData,
      selectedCards: cobrandData.selectedCards.filter(({ cardname }) => cardname !== id),
    });
  };
  const shellSubtitle = index === 2 ? 'Select a card (optional)' : 'Select a card (required)';
  const normalizedCardType: CardType = item?.cardType ?? 'none';

  return (
    <StyledCompareCard
      className={styleClass}
      data-testid="cobrand-CompareCard"
      data-component-name="m-cobrand-CompareCard"
    >
      {defaultContent ? (
        <div className="card-shell d-flex justify-content-center align-items-center flex-column">
          <Text copyText={`Card ${index + 1}`} fontSize={size.small} element={tags.span} customClass="mb-1" />
          {!hideShellSubtitle && (
            <Text
              copyText={shellSubtitle}
              fontSize={size.extraSmall}
              element={tags.span}
              customClass="shell-subtitle"
            />
          )}
        </div>
      ) : (
        <div
          className={clsx(
            'card-container d-flex flex-md-column align-items-md-center justify-content-center',
            isLandscape ? 'flex-column align-items-center pt-4' : ''
          )}
        >
          {normalizedCardType !== 'none' && (
            <div className={clsx('card-tag d-none d-md-block', applyTagStyles(normalizedCardType))}>
              <Text copyText={normalizedCardType} fontSize={size.extraSmall} element={tags.paragraph} />
            </div>
          )}
          {item?.cardname && (
            <MButton
              className="icon-clear remove-card"
              buttonType={MButtonType.Primary}
              onClick={() => {
                if (item.cardname) handleRemove(item.cardname);
              }}
              aria-label="Remove card from comparison"
            />
          )}
          <div className="comparison-card-image-container mt-md-2">
            <CobrandImage defaultImageURL={item?.imagePath} customClass="card-image" altText={item?.altText} />
          </div>
          <div className="ml-2 ml-md-0 mt-1 mt-md-0">
            {normalizedCardType !== 'none' && (
              <div
                className={clsx(
                  isLandscape ? 'card-tag' : 'card-sm-tag',
                  'd-md-none',
                  applyTagStyles(normalizedCardType)
                )}
              >
                <Text copyText={normalizedCardType} fontSize={size.extraSmall} element={tags.paragraph} />
              </div>
            )}
            {item?.header && (
              <Text
                copyText={item.header}
                fontSize={size.extraSmall}
                element={tags.div}
                customClass={clsx(
                  'mt-2 d-flex text-md-center align-items-center card-header',
                  isLandscape ? 'text-center' : ''
                )}
              />
            )}
          </div>
        </div>
      )}
    </StyledCompareCard>
  );
};
